<template>
  <div>
    <Account_setting/>
  </div>
</template>

<script>
import Account_setting from "@/components/adminArin/setting_account/Account_setting";
export default {
  name: "AccountSetting",
  components: {
    Account_setting
  }
}
</script>

<style scoped>

</style>
